module.exports = __webpack_public_path__ + "static/media/cUSDT-logo.dcd437f3.png";